import * as React from 'react';
import { Action } from 'history';
import _ from 'lodash';
import { Prompt } from 'react-router';
import { WarningModal } from '../../components/common/WarningModal';
import ContentConstants from '../../contentConstants';
import { ISurveyBuilderActionCreators } from '../../models';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';

export type PageStateSetterBaseProps = {
	isLoading: boolean;
} & ISurveyBuilderState &
	ISurveyBuilderActionCreators;

export class PageStateSetterBase extends React.Component<PageStateSetterBaseProps, { openWarningModal: boolean }> {
	constructor(props: PageStateSetterBaseProps) {
		super(props);

		this.state = { openWarningModal: this.props.openWarningModal };

		this.continue = this.continue.bind(this);
		this.interference = this.interference.bind(this);
	}

	public UNSAFE_componentWillReceiveProps(props: PageStateSetterBaseProps) {
		this.props.CheckForUnsavedChanges();
		if (!_.isEqual(this.props, props) && !props.saving && !props.isLoading) {
			if (this.state.openWarningModal !== props.openWarningModal) {
				this.setState({
					openWarningModal: props.openWarningModal,
				});
			}
		}
	}

	public render() {
		const { saving, hasUnsavedChanges } = this.props;
		const { openWarningModal } = this.state;

		return (
			<>
				<Prompt when={!saving && hasUnsavedChanges} message={this.interference} />
				<WarningModal
					isOpen={openWarningModal}
					onClose={this.props.WarningModalCancel}
					onSubmit={this.continue}
					contentHeadline={ContentConstants.WARNING_MODAL_UNSAVED_HEADLINE}
					contentBody={ContentConstants.WARNING_MODAL_UNSAVED_BODY}
				/>
			</>
		);
	}

	public interference(location: any, action: Action) {
		if (this.props.hasUnsavedChanges && this.state.openWarningModal) {
			this.props.RequestRouting(location.pathname, true);
		}

		return true;
	}

	public continue() {
		this.setState(
			{
				openWarningModal: false,
			},
			this.props.WarningModalContinue,
		);
	}
}
